import * as StyleConstants from '../constants';
import * as FontSizes from '../azure-type';
export var CheckStyles = function (props) {
    var theme = props.theme, checked = props.checked;
    var semanticColors = theme.semanticColors;
    return {
        circle: [
            {
                fontSize: 0,
                paddingTop: 1,
                paddingLeft: 1,
                borderRadius: 2,
                color: semanticColors.listBackground,
                backgroundColor: semanticColors.listBackground,
                borderColor: semanticColors.ButtonBorderFocus,
                borderWidth: StyleConstants.borderWidth,
                borderStyle: StyleConstants.borderSolid,
            },
        ],
        check: [
            {
                left: 2.5,
                top: 1.5,
            },
            checked && {
                color: semanticColors.inputText,
            },
            !checked && {
                color: semanticColors.listBackground,
            },
        ],
    };
};
export var DetailsListStyles = function (props) {
    var theme = props.theme;
    var semanticColors = theme.semanticColors;
    var extendedSemanticColors = semanticColors;
    return {
        root: {
            borderTop: StyleConstants.borderNone,
            selectors: {
                '.ms-DetailsRow-check': {
                    opacity: 1,
                },
            },
        },
        headerWrapper: {
            selectors: {
                '.ms-DetailsHeader': {
                    borderColor: extendedSemanticColors.rowBorder,
                    borderTop: StyleConstants.borderNone,
                    selectors: {
                        '.ms-DetailsHeader-cellTitle': {
                            backgroundColor: semanticColors.listBackground,
                            borderRightWidth: StyleConstants.borderWidth,
                            borderRightStyle: StyleConstants.borderSolid,
                            borderRightColor: semanticColors.listBackground,
                            fontSize: FontSizes.size10,
                            fontWeight: 700,
                        },
                        ':hover .ms-DetailsHeader-cellTitle': {
                            borderRightWidth: StyleConstants.borderWidth,
                            borderRightStyle: StyleConstants.borderSolid,
                            borderRightColor: semanticColors.variantBorder,
                        },
                        '.is-checked': {
                            '.ms-Check-circle': {
                                backgroundColor: extendedSemanticColors.checkboxBackgroundChecked,
                                borderColor: extendedSemanticColors.checkBoxCheck,
                            },
                            '.ms-Check-check': {
                                color: extendedSemanticColors.checkBoxCheck,
                            },
                        },
                        '.ms-DetailsHeader-check:hover': {
                            '.ms-Check-check': {
                                color: extendedSemanticColors.checkBoxCheckHover,
                            },
                            '.is-checked': {
                                '.ms-Check-circle': {
                                    backgroundColor: extendedSemanticColors.checkboxBackgroundHovered,
                                },
                                '.ms-Check-check': {
                                    color: extendedSemanticColors.checkBoxCheck,
                                },
                            },
                        },
                    },
                },
            },
        },
    };
};
export var DetailsRowStyles = function (props) {
    var theme = props.theme, isSelected = props.isSelected;
    var semanticColors = theme.semanticColors;
    var extendedSemanticColors = semanticColors;
    return {
        root: [
            {
                borderColor: 'red',
                color: semanticColors.listText,
                fontSize: theme.fonts.small.fontSize,
                borderBottom: "1px solid #dee2e6 !important",
                selectors: {
                    '.ms-DetailsRow-check': {
                        opacity: 1,
                    },
                },
            },
            !isSelected && [
                {
                    background: semanticColors.listBackground,
                    selectors: {
                        ':hover': {
                            backgroundColor: semanticColors.listItemBackgroundHovered,
                            selectors: {
                                '.ms-Check-check': {
                                    color: extendedSemanticColors.checkBoxCheckHover,
                                },
                                '.ms-Link': {
                                    color: extendedSemanticColors.listLinkRowHovered,
                                },
                                '.ms-Link:hover': {
                                    color: extendedSemanticColors.listLinkHovered,
                                },
                            },
                        },
                        ':after': {
                            border: "1px solid ".concat(extendedSemanticColors.listItemBackgroundSelected, " !important"),
                        },
                        ':focus': {
                            backgroundColor: extendedSemanticColors.rowFocus,
                        },
                    },
                },
            ],
            isSelected && [
                {
                    backgroundColor: extendedSemanticColors.listItemBackgroundSelected,
                    textDecoration: extendedSemanticColors.listUnderline,
                    fontWeight: StyleConstants.fontWeightRegular,
                    selectors: {
                        '.ms-DetailsRow-cell': {
                            fontWeight: StyleConstants.fontWeightRegular,
                        },
                        '.ms-Check-circle': {
                            backgroundColor: extendedSemanticColors.checkboxBackgroundChecked,
                            borderColor: extendedSemanticColors.checkBoxCheck,
                        },
                        '.ms-Check-check': {
                            color: extendedSemanticColors.checkBoxCheck,
                        },
                        '.ms-Link': {
                            color: extendedSemanticColors.listLinkRowSelected,
                        },
                        ':hover': {
                            background: extendedSemanticColors.listItemBackgroundSelectedHovered,
                            selectors: {
                                '.ms-Link': {
                                    color: extendedSemanticColors.listLinkRowSelectedHovered,
                                },
                                '.ms-Check-circle': {
                                    backgroundColor: extendedSemanticColors.checkboxBackgroundHovered,
                                },
                            },
                        },
                    },
                },
            ],
        ],
    };
};
